/**
 * Dark academia color palette and font definitions.
 * This file is the single source of truth for all theme values.
 *
 * Colors are duplicated in tailwind.config.js for NativeWind class usage.
 * If you change a value here, update tailwind.config.js to match.
 */

import { Platform } from 'react-native';
import { DefaultTheme, type Theme } from '@react-navigation/native';

export const Colors = {
  light: {
    background: '#F5F0E8',
    surface: '#FFFFFF',
    card: '#FFFFFF',
    cardText: '#2C1810',
    text: '#1A1209',
    textMuted: '#6B5D4F',
    accent: '#8B6914',
    border: '#D4C5A9',
  },
  dark: {
    background: '#0F1A2E',
    surface: '#1A2744',
    card: '#F5F0E8',
    cardText: '#2C1810',
    text: '#E8E0D4',
    textMuted: '#9A8E7F',
    accent: '#C9A84C',
    border: '#2A3A5C',
  },
};

export const Fonts = Platform.select({
  ios: {
    sans: 'system-ui',
    serif: 'CormorantGaramond_400Regular',
    serifMedium: 'CormorantGaramond_500Medium',
    serifSemiBold: 'CormorantGaramond_600SemiBold',
    serifBold: 'CormorantGaramond_700Bold',
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'CormorantGaramond_400Regular',
    serifMedium: 'CormorantGaramond_500Medium',
    serifSemiBold: 'CormorantGaramond_600SemiBold',
    serifBold: 'CormorantGaramond_700Bold',
    mono: 'monospace',
  },
  web: {
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    serif: 'CormorantGaramond_400Regular',
    serifMedium: 'CormorantGaramond_500Medium',
    serifSemiBold: 'CormorantGaramond_600SemiBold',
    serifBold: 'CormorantGaramond_700Bold',
    mono: "SFMono-Regular, Menlo, Monaco, Consolas, 'Courier New', monospace",
  },
});

export function navigationTheme(scheme: 'light' | 'dark'): Theme {
  const c = Colors[scheme];
  return {
    dark: scheme === 'dark',
    colors: {
      primary: c.accent,
      background: c.background,
      card: c.surface,
      text: c.text,
      border: c.border,
      notification: c.accent,
    },
    fonts: DefaultTheme.fonts,
  };
}
